let xrayTypes = {
    intraoral: {
        label: 'Intraoral',
        value: 'intraoral',
        dose: 2.5
    },
    orthopantomogram: {
        label: 'Orthopantomogram',
        value: 'orthopantomogram',
        dose: 3
    },
    ct: {
        label: 'CT scan',
        value: 'ct',
        dose: 10
    },
    ct_up_low_jaw: {
        label: 'x-ray.ct_up_low_jaw',
        value: 'ct_up_low_jaw',
        dose: 30
    },
    ct_up_low_tmj_jaw: {
        label: 'x-ray.ct_up_low_tmj_jaw',
        value: 'ct_up_low_tmj_jaw',
        dose: 30
    },
    ct_up_ms_jaw: {
        label: 'x-ray.ct_up_ms_jaw',
        value: 'ct_up_ms_jaw',
        dose: 30
    },
    tgr_lateral_projection: {
        label: 'x-ray.tgr_lateral_projection',
        value: 'tgr_lateral_projection',
        dose: 10
    },
    tgr_front_projection: {
        label: 'x-ray.tgr_front_projection',
        value: 'tgr_front_projection',
        dose: 10
    },
    tgr_subchinoparietal_projection: {
        label: 'x-ray.tgr_subchinoparietal_projection',
        value: 'tgr_subchinoparietal_projection',
        dose: 10
    },
    section4_tmj: {
        label: 'x-ray.section4_tmj',
        value: 'section4_tmj',
        dose: 10
    },
    section6_tmj: {
        label: 'x-ray.section6_tmj',
        value: 'section6_tmj',
        dose: 15
    },

    other: {
        label: 'Other',
        value: 'other'
    },
};

let doses = {
    intraoral: 2.5,
    orthopantomogram: 3,
    ct: 10,
    ct_up_low_jaw: 30,
    ct_up_low_tmj_jaw: 30,
    ct_up_ms_jaw: 30,
    tgr_lateral_projection: 10,
    tgr_front_projection: 10,
    tgr_subchinoparietal_projection: 10,
    section4_tmj: 10,
    section6_tmj: 15

};
export {
    xrayTypes,
    doses
};
export default function (status) {
    let statused;

    if (xrayTypes[status]) {
        statused = xrayTypes[status];
    } else {
        statused = {
            label: status
        }
    }

    return statused;
};
